import React, { useState, useEffect } from "react";
import "../Styles/DevicesContent.css";
import {
  Dropdown,
  DefaultButton,
  PrimaryButton,
  Dialog,
  DialogType,
  Panel,
  PanelType,
  Toggle,
  SpinButton
} from "@fluentui/react";
import { useBoolean } from "@fluentui/react-hooks";
import Axios from "axios";


const DevicesContent = ({ project, panelVersion }) => {
  const [selectedLoop, setSelectedLoop] = useState(0);
  const [selectedDevice, setSelectedDevice] = useState(null); // Store selected device index
  const [isPanelOpen, { setTrue: openPanel, setFalse: dismissPanel }] = useBoolean(false);
  const [isWeeklyTrendDialogOpen, setIsWeeklyTrendDialogOpen] = useState(false);
  const [isDeactivateWeeklyTrendDialogOpen, setIsDeactivateWeeklyTrendDialogOpen] = useState(false);
  const [selectWeeklyTrendBlock, setSelectWeeklyTrendBlock] = useState(null);
  const [selectDeactivateWeeklyTrendBlock, setSelectDeactivateWeeklyTrendBlock] = useState(null);
  const [name, setName] = useState("");
  const [tempName, setTempName] = useState("");
  const [isRadio, setIsRadio] = useState(false);
  const [tempIsRadio, setTempIsRadio] = useState(false);
  // Reset Detectors
  const [evacuationEnabled, setEvacuationEnabled] = useState(false);
  const [tempEvacuationEnabled, setTempEvacuationEnabled] = useState(false);
  const [volume, setVolume] = useState(0);
  const [tempVolume, setTempVolume] = useState(0);
  const [tone, setTone] = useState(0);
  const [tempTone, setTempTone] = useState(0);
  const [alarmVerification, setAlarmVerification] = useState(false);
  const [tempAlarmVerification, setTempAlarmVerification] = useState(false);
  const [alarmVerificationDelay, setAlarmVerificationDelay] = useState(0);
  const [tempAlarmVerificationDelay, setTempAlarmVerificationDelay] = useState(0);
  const [technical, setTechnical] = useState(false);
  const [tempTechnical, setTempTechnical] = useState(false);
  const [prealarm, setPrealarm] = useState(false);
  const [tempPrealarm, setTempPrealarm] = useState(false);
  const [preAllTemp, setPreAllTemp] = useState(0);
  const [tempPreAllTemp, setTempPreAllTemp] = useState(0);
  const [sounderBase, setSounderBase] = useState(false);
  const [tempSounderBase, setTempSounderBase] = useState(false);
  const [dayNight, setDayNight] = useState(0);
  const [tempDayNight, setTempDayNight] = useState(0);
  const [detectorDaySensitivity, setDetectorDaySensitivity] = useState(0);
  const [tempDetectorDaySensitivity, setTempDetectorDaySensitivity] = useState(0);
  const [intendedDisChannel, setIntendedDisChannel] = useState(0);
  const [tempIntendedDisChannel, setTempIntendedDisChannel] = useState(0);
  const [detectorSensitivityWeekCalendar, setDetectorSensitivityWeekCalendar] = useState(0);
  const [tempDetectorSensitivityWeekCalendar, setTempDetectorSensitivityWeekCalendar] = useState(0);
  const [sensSecDis, setSensSecDis] = useState(0);
  const [tempSensSecDisDay, setTempSensSecDisDay] = useState(0);
  const [tempSensSecDisNight, setTempSensSecDisNight] = useState(0);
  const [detectorMultiSenseWeekCalendar, setDetectorMultiSenseWeekCalendar] = useState(0);
  const [tempDetectorMultiSenseWeekCalendar, setTempDetectorMultiSenseWeekCalendar] = useState(0);
  const [selectedDeviceType, setSelectedDeviceType] = useState(null); // 'Smoke', 'Thermal', etc.
  const [technicalFault, setTechnicalFault] = useState(false);
  const [tempTechnicalFault, setTempTechnicalFault] = useState(false);
  const [technicalRestore, setTechnicalRestore] = useState(false);
  const [tempTechnicalRestore, setTempTechnicalRestore] = useState (false);
  const [secDisEn, setSecDisEn] = useState(0);
  const [tempSecDisEn, setTempSecDisEn] = useState(0);


  useEffect(() => {
    if (selectedDevice !== null && project.panel) {
      const i = selectedLoop;
      const j = selectedDevice;
      const device = project.panel.VT5000_CONFIG.ArgusTablePr?.[i]?.[j];

      if (device) {
        setName(device.name.replace(/\u0000/g, ''));
        setTempName(device.name.replace(/\u0000/g, ''));
        setIsRadio(device.isRadio === 1);
        setTempIsRadio(device.isRadio === 1);
        setEvacuationEnabled(device.evacuationEnabled === 1);
        setTempEvacuationEnabled(device.evacuationEnabled === 1);
        setVolume(device.volume);
        setTempVolume(device.volume);
        setTone(device.tone);
        setTempTone(device.tone);
        setAlarmVerification(device.alarmVerification === 1);
        setTempAlarmVerification(device.alarmVerification === 1);
        setAlarmVerificationDelay(device.alarmVerificationDelay);
        setTempAlarmVerificationDelay(device.alarmVerificationDelay);
        setTechnical(device.technical > 0);
        setTempTechnical(device.technical > 0);
        setPrealarm(device.prealarm === 1);
        setTempPrealarm(device.prealarm === 1);
        setPreAllTemp(device.preAllTemp);
        setTempPreAllTemp(device.preAllTemp);
        setSounderBase(device.sounderBase === 1);
        setTempSounderBase(device.sounderBase === 1);
        setDayNight(device.dayNight);
        setTempDayNight(device.dayNight);
        setDetectorDaySensitivity(device.detectorDaySensitivity);
        setTempDetectorDaySensitivity(device.detectorDaySensitivity);
        setIntendedDisChannel(device.intendedDisChannel);
        setTempIntendedDisChannel(device.intendedDisChannel);
        setDetectorSensitivityWeekCalendar(device.detectorSensitivityWeekCalendar);
        setTempDetectorSensitivityWeekCalendar(device.detectorSensitivityWeekCalendar);
        setSensSecDis(device.sensSecDis);
        setTechnicalFault(device.technicalFault > 0);
        setTempTechnicalFault(device.technicalFault > 0);
        setTechnicalRestore(device.technicalRestore > 0);
        setTempTechnicalRestore(device.technicalRestore > 0);

        switch (device.sensSecDis) {
          case 7:
            setTempSensSecDisDay(1);
            setTempSensSecDisNight(1);
            setTempSecDisEn(1);
            break;
          case 6:
            setTempSensSecDisDay(2);
            setTempSensSecDisNight(1);
            setTempSecDisEn(1);
            break;
          case 5:
            setTempSensSecDisDay(0);
            setTempSensSecDisNight(1);
            setTempSecDisEn(1);
            break;
          case 4:
            setTempSensSecDisDay(1);
            setTempSensSecDisNight(2);
            setTempSecDisEn(1);
            break;
          case 3:
            setTempSensSecDisDay(2);
            setTempSensSecDisNight(2);
            setTempSecDisEn(1);
            break;
          case 2:
            setTempSensSecDisDay(0);
            setTempSensSecDisNight(2);
            setTempSecDisEn(1);
            break;
          case 1:
            setTempSensSecDisDay(1);
            setTempSensSecDisNight(0);
            setTempSecDisEn(1);
            break;
          default:
            if (device.secDisEn === 0) {
              setTempSensSecDisDay(0);
              setTempSensSecDisNight(0);
              setTempSecDisEn(0);
            }
            else {
              setTempSensSecDisDay(2);
              setTempSensSecDisNight(0);
              setTempSecDisEn(1);
            }
        }

        setDetectorMultiSenseWeekCalendar(device.detectorMultiSenseWeekCalendar);
        setTempDetectorMultiSenseWeekCalendar(device.detectorMultiSenseWeekCalendar);
        setSelectWeeklyTrendBlock(device.detectorSensitivityWeekCalendar - 1);
        setSelectDeactivateWeeklyTrendBlock(device.detectorMultiSenseWeekCalendar - 1);

        if (device.programmed === 1) {
          const isModule = device.deviceType === 1;
          const isDevice = device.deviceType === 0;
          const isSmoke = isDevice && device.lastTipo === 0 && device.isMultiSensor === 0;
          const isThermal = isDevice && device.lastTipo === 1;
          const isSmokeTherm = isDevice && device.lastTipo === 0 && device.isMultiSensor === 1;
          const isCallPoint = isModule && device.lastTipo === 3 && device.isCallPoint === 1;
          const isGas = isModule && device.lastTipo === 3 && device.isGas === 1;
          const isInput = isModule && device.lastTipo === 3 && !isCallPoint && !isGas;
          const isFlasher = isModule && device.lastTipo === 4 && device.isFlasher === 1;
          const isSiren = isModule && device.lastTipo === 4 && device.isSounder === 1;
          const isRepeater = isModule && device.lastTipo === 4 && device.isRepeater === 1;
          const isOutput = isModule && device.lastTipo === 4 && !isFlasher && !isSiren && !isRepeater;
          const isExpander = isModule && device.lastTipo === 5;
      
          if (isThermal) setSelectedDeviceType("Thermal");
          else if (isSmokeTherm) setSelectedDeviceType("Smoke Therm.");
          else if (isCallPoint) setSelectedDeviceType("Call point");
          else if (isGas) setSelectedDeviceType("Gas");
          else if (isInput) setSelectedDeviceType("Input");
          else if (isFlasher) setSelectedDeviceType("Flasher");
          else if (isSiren) setSelectedDeviceType("Siren");
          else if (isRepeater) setSelectedDeviceType("Rep.Led");
          else if (isOutput) setSelectedDeviceType("Output");
          else if (isExpander) setSelectedDeviceType("XPander");
          else setSelectedDeviceType("Smoke");
        }
      }
    }
  }, [selectedDevice, selectedLoop, project]);

  if (!project || !project.panel || Object.keys(project.panel).length === 0) {
    return <div>No panel data found.</div>;
  }

  const loopCardNb = project.panel.VT5000_CONFIG.GeneralParameters?.loopCardNb || 0;
  const loopButtonsCount = 1 + 2 * loopCardNb;

  const handleLoopButtonClick = (index) => {
    setSelectedLoop(index);
  };

  const handleDeviceButtonClick = (index) => {
    setSelectedDevice(index);
    openPanel();
  };

  const handleWeeklyTrendBlockClick = (index) => {
    setSelectWeeklyTrendBlock(index);
    setTempDetectorSensitivityWeekCalendar(index + 1);
    setIsWeeklyTrendDialogOpen(false);
  };

  const handleDeactivateWeeklyTrendBlockClick = (index) => {
    setSelectDeactivateWeeklyTrendBlock(index);
    setTempDetectorMultiSenseWeekCalendar(index + 1);
    setIsDeactivateWeeklyTrendDialogOpen(false);
  };

  const renderPanelContent = () => {
    const i = selectedLoop;
    const j = selectedDevice;
    const device = project.panel.VT5000_CONFIG.ArgusTablePr?.[i]?.[j];
  
    // Helper: infer type booleans from string (for unprogrammed mode)
    const getBooleansFromType = (type) => ({
      isSmoke: type === "Smoke",
      isThermal: type === "Thermal",
      isSmokeTherm: type === "Smoke Therm.",
      isInput: type === "Input",
      isCallPoint: type === "Call point",
      isGas: type === "Gas",
      isOutput: type === "Output",
      isFlasher: type === "Flasher",
      isSiren: type === "Siren",
      isRepeater: type === "Rep.Led",
      isExpander: type === "XPander"
    });
  
    // Render full UI if programmed device exists
    if (device?.programmed === 1) {
      // Determine device type flags
      const isModule = device.deviceType === 1;
      const isDevice = device.deviceType === 0;
      const isSmoke = isDevice && device.lastTipo === 0 && device.isMultiSensor === 0;
      const isThermal = isDevice && device.lastTipo === 1;
      const isSmokeTherm = isDevice && device.lastTipo === 0 && device.isMultiSensor === 1;
      const isCallPoint = isModule && device.lastTipo === 3 && device.isCallPoint === 1;
      const isGas = isModule && device.lastTipo === 3 && device.isGas === 1;
      const isInput = isModule && device.lastTipo === 3 && !isCallPoint && !isGas;
      const isFlasher = isModule && device.lastTipo === 4 && device.isFlasher === 1;
      const isSiren = isModule && device.lastTipo === 4 && device.isSounder === 1;
      const isRepeater = isModule && device.lastTipo === 4 && device.isRepeater === 1;
      const isOutput = isModule && device.lastTipo === 4 && !isFlasher && !isSiren && !isRepeater;
      const isExpander = isModule && device.lastTipo === 5;
  
      let deviceType = "Smoke";
      if (isThermal) deviceType = "Thermal";
      else if (isSmokeTherm) deviceType = "Smoke Therm.";
      else if (isCallPoint) deviceType = "Call point";
      else if (isGas) deviceType = "Gas";
      else if (isInput) deviceType = "Input";
      else if (isFlasher) deviceType = "Flasher";
      else if (isSiren) deviceType = "Siren";
      else if (isRepeater) deviceType = "Rep.Led";
      else if (isOutput) deviceType = "Output";
      else if (isExpander) deviceType = "XPander";
  
      return renderDeviceUI({ deviceType, isSmoke, isThermal, isSmokeTherm, isInput, isCallPoint, isGas, isOutput, isFlasher, isSiren, isRepeater, isExpander });
    }
  
    // Render if user clicked a button manually (unprogrammed device type)
    if (selectedDeviceType) {
      return (
        <div>
          <DefaultButton text="← Back" onClick={() => setSelectedDeviceType(null)} />
          {renderDeviceUI({ deviceType: selectedDeviceType, ...getBooleansFromType(selectedDeviceType) })}
        </div>
      );
    }
  
    // Default view: unprogrammed with device type selection
    return (
      <div>
        <h4>Device</h4>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          <DefaultButton text="Smoke" onClick={() => setSelectedDeviceType("Smoke")} />
          <DefaultButton text="Thermal" onClick={() => setSelectedDeviceType("Thermal")} />
          <DefaultButton text="Smoke Therm." onClick={() => setSelectedDeviceType("Smoke Therm.")} />
        </div>
        <h4>Module</h4>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          <DefaultButton text="Input" onClick={() => setSelectedDeviceType("Input")} />
          <DefaultButton text="Call point" onClick={() => setSelectedDeviceType("Call point")} />
          <DefaultButton text="Gas" onClick={() => setSelectedDeviceType("Gas")} />
          <DefaultButton text="Output" onClick={() => setSelectedDeviceType("Output")} />
          <DefaultButton text="Flasher" onClick={() => setSelectedDeviceType("Flasher")} />
          <DefaultButton text="Siren" onClick={() => setSelectedDeviceType("Siren")} />
          <DefaultButton text="Rep.Led" onClick={() => setSelectedDeviceType("Rep.Led")} />
          <DefaultButton text="XPander" onClick={() => setSelectedDeviceType("XPander")} />
        </div>
      </div>
    );
  };

  const renderDeviceUI = ({
    deviceType,
    isSmoke,
    isThermal,
    isSmokeTherm,
    isInput,
    isCallPoint,
    isGas,
    isOutput,
    isFlasher,
    isSiren,
    isRepeater,
    isExpander,
  }) => {
    return (
      <div>
        <h2>
          {deviceType}
        </h2>
        <label htmlFor="nameInput">Module Name:</label>
        <input
          id="nameInput"
          type="text"
          value={tempName}
          onChange={(e) => setTempName(e.target.value)}
          placeholder={name}
        />
        <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px", height: "32px" }}>
          <span style={{ display: "flex", alignItems: "center", fontSize: "16px" }}>Radio:</span>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Toggle
              styles={{
                root: { marginBottom: "0px", padding: "0px" },
                label: { display: "none" }, // Hide Fluent UI’s built-in label
                pill: { marginTop: "0px", alignSelf: "center" },
                thumb: { marginTop: "0px" },
              }}
              checked={tempIsRadio}
              onChange={() => setTempIsRadio(!tempIsRadio)}
              onText="Yes"
              offText="No"
            />
          </div>
        </div>
        {/* Reset Detectors */}
        {(isSmoke || isThermal || isSmokeTherm) && (<div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px", height: "32px" }}>
          <span style={{ display: "flex", alignItems: "center", fontSize: "16px" }}>Slave Sounder:</span>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Toggle
              styles={{
                root: { marginBottom: "0px", padding: "0px" },
                label: { display: "none" }, // Hide Fluent UI’s built-in label
                pill: { marginTop: "0px", alignSelf: "center" },
                thumb: { marginTop: "0px" },
              }}
              checked={tempSounderBase}
              onChange={() => setTempSounderBase(!tempSounderBase)}
              onText="Yes"
              offText="No"
            />
          </div>
        </div>)}
        {(isOutput || isFlasher || isSiren || isRepeater || (isSmoke && tempSounderBase) || (isThermal && tempSounderBase) || (isSmokeTherm && tempSounderBase)) && (<div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px", height: "32px" }}>
          <span style={{ display: "flex", alignItems: "center", fontSize: "16px" }}>Activate Evacuation:</span>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Toggle
              styles={{
                root: { marginBottom: "0px", padding: "0px" },
                label: { display: "none" }, // Hide Fluent UI’s built-in label
                pill: { marginTop: "0px", alignSelf: "center" },
                thumb: { marginTop: "0px" },
              }}
              checked={tempEvacuationEnabled}
              onChange={() => setTempEvacuationEnabled(!tempEvacuationEnabled)}
              onText="Yes"
              offText="No"
            />
          </div>
        </div>)}
        {isSiren && (<div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px", height: "32px" }}>
          <span style={{ display: "flex", alignItems: "center", fontSize: "16px" }}>Volume:</span>
          <div style={{ display: "flex", alignItems: "center", width: "100px" }}>
            <SpinButton
              min={0}
              max={31}
              value={tempVolume.toString()} // Ensure the value is a string
              onChange={(event, newValue) => {
                const parsedValue = parseInt(newValue, 10);
                if (!isNaN(parsedValue) && parsedValue >= 0 && parsedValue <= 31) {
                  setTempVolume(parsedValue);
                }
              }}
              styles={{
                root: { marginBottom: "0px", padding: "0px", width: "100%" },
                spinButtonWrapper: { height: "32px", display: "flex", alignItems: "center" },
                input: { textAlign: "center", fontSize: "14px" },
              }}
            />
          </div>
        </div>)}
        {isSiren && (<div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px", height: "32px" }}>
          <span style={{ display: "flex", alignItems: "center", fontSize: "16px" }}>Tone:</span>
          <div style={{ display: "flex", alignItems: "center", width: "100px" }}>
            <SpinButton
              min={0}
              max={4}
              value={tempTone.toString()} // Ensure the value is a string
              onChange={(event, newValue) => {
                const parsedValue = parseInt(newValue, 10);
                if (!isNaN(parsedValue) && parsedValue >= 0 && parsedValue <= 31) {
                  setTempTone(parsedValue);
                }
              }}
              styles={{
                root: { marginBottom: "0px", padding: "0px", width: "100%" },
                spinButtonWrapper: { height: "32px", display: "flex", alignItems: "center" },
                input: { textAlign: "center", fontSize: "14px" },
              }}
            />
          </div>
        </div>)}
        {(isSmoke || isThermal || isSmokeTherm || isInput || isCallPoint || isGas) && (<div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px", height: "32px" }}>
          <span style={{ display: "flex", alignItems: "center", fontSize: "16px" }}>Verify Alarms:</span>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Toggle
              styles={{
                root: { marginBottom: "0px", padding: "0px" },
                label: { display: "none" }, // Hide Fluent UI’s built-in label
                pill: { marginTop: "0px", alignSelf: "center" },
                thumb: { marginTop: "0px" },
              }}
              checked={tempAlarmVerification}
              onChange={(event, checked) => {
                setTempAlarmVerification(checked);
                // New rule:
                // - If NOT 2.0.F7 and turned on → snap to 2.5 minutes (key=5)
                // - If 2.0.F7 → keep old behavior (don't auto-change delay)
                if (checked && panelVersion !== "2.0.F7") {
                  setTempAlarmVerificationDelay(5);
                }
              }}
              onText="Yes"
              offText="No"
            />
          </div>
        </div>)}
        {(isSmoke || isThermal || isSmokeTherm || isInput || isCallPoint || isGas) && (<div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px", height: "32px" }}>
          <span style={{ display: "flex", alignItems: "center", fontSize: "16px" }}>Verify Minutes:</span>
          <div style={{ display: "flex", alignItems: "center", width: "100px" }}>
            <Dropdown
              styles={{
                root: { marginBottom: "0px", padding: "0px", width: "100%" },
                title: { height: "32px", lineHeight: "32px", textAlign: "center" },
                dropdown: { width: "100px" },
              }}
              disabled={!tempAlarmVerification}
              options={Array.from({ length: 30 }, (_, i) => {
                const display = ((i + 1) * 0.5).toFixed(1);  // 0.5, 1.0, ..., 15.0
                const value = (i + 1); // 1, 2, ..., 30
                return { key: value, text: display };
              })}
              selectedKey={tempAlarmVerificationDelay}
              onChange={(event, option) => setTempAlarmVerificationDelay(option.key)}
            />
          </div>
        </div>)}
        {(isInput || isCallPoint || isGas) && (<div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px", height: "32px" }}>
          <span style={{ display: "flex", alignItems: "center", fontSize: "16px" }}>Technological:</span>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Toggle
              styles={{
                root: { marginBottom: "0px", padding: "0px" },
                label: { display: "none" }, // Hide Fluent UI’s built-in label
                pill: { marginTop: "0px", alignSelf: "center" },
                thumb: { marginTop: "0px" },
              }}
              checked={tempTechnical}
              onChange={() => setTempTechnical(!tempTechnical)}
              onText="Yes"
              offText="No"
            />
          </div>
        </div>)}
        {tempTechnical && (<div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px", height: "32px" }}>
          <span style={{ display: "flex", alignItems: "center", fontSize: "16px" }}>Fault:</span>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Toggle
              styles={{
                root: { marginBottom: "0px", padding: "0px" },
                label: { display: "none" }, // Hide Fluent UI’s built-in label
                pill: { marginTop: "0px", alignSelf: "center" },
                thumb: { marginTop: "0px" },
              }}
              checked={tempTechnicalFault}
              onChange={() => setTempTechnicalFault(!tempTechnicalFault)}
              onText="Yes"
              offText="No"
            />
          </div>
        </div>)}
        {tempTechnical && (<div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px", height: "32px" }}>
          <span style={{ display: "flex", alignItems: "center", fontSize: "16px" }}>Self Restore:</span>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Toggle
              styles={{
                root: { marginBottom: "0px", padding: "0px" },
                label: { display: "none" }, // Hide Fluent UI’s built-in label
                pill: { marginTop: "0px", alignSelf: "center" },
                thumb: { marginTop: "0px" },
              }}
              checked={tempTechnicalRestore}
              onChange={() => setTempTechnicalRestore(!tempTechnicalRestore)}
              onText="Yes"
              offText="No"
            />
          </div>
        </div>)}
        {tempTechnical && (<div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px", height: "32px" }}>
          <span style={{ display: "flex", alignItems: "center", fontSize: "16px" }}>Prealarm:</span>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Toggle
              styles={{
                root: { marginBottom: "0px", padding: "0px" },
                label: { display: "none" }, // Hide Fluent UI’s built-in label
                pill: { marginTop: "0px", alignSelf: "center" },
                thumb: { marginTop: "0px" },
              }}
              checked={tempPrealarm}
              onChange={() => setTempPrealarm(!tempPrealarm)}
              onText="Yes"
              offText="No"
            />
          </div>
        </div>)}
        {tempTechnical && (<div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px", height: "32px" }}>
          <span style={{ display: "flex", alignItems: "center", fontSize: "16px" }}>Prealarm Period:</span>
          <div style={{ display: "flex", alignItems: "center", width: "100px" }}>
            <Dropdown
              styles={{
                root: { marginBottom: "0px", padding: "0px", width: "100%" },
                title: { height: "32px", lineHeight: "32px", textAlign: "center" },
                dropdown: { width: "100px" },
              }}
              options={Array.from({ length: 256 }, (_, i) => ({ key: i, text: `${i}` }))}
              selectedKey={tempPreAllTemp}
              onChange={(event, option) => setTempPreAllTemp(option.key)}
            />
          </div>
        </div>)}
        {(isSmoke || isSmokeTherm) && (<div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px", height: "32px" }}>
          <span style={{ display: "flex", alignItems: "center", fontSize: "16px" }}>Management Sensitivity:</span>
          <div style={{ display: "flex", alignItems: "center", width: "120px" }}>
            <Dropdown
              styles={{
                root: { marginBottom: "0px", padding: "0px", width: "100%" },
                title: { height: "32px", lineHeight: "32px", textAlign: "center" },
                dropdown: { width: "120px" },
              }}
              options={[
                { key: 0, text: "24H" },
                { key: 1, text: "Night" },
                { key: 2, text: "Fixed" },
              ]}
              selectedKey={tempDayNight} // ✅ Shows the default value
              onChange={(event, option) => setTempDayNight(option.key)}
            />
          </div>
        </div>)}
        {(isSmoke || isSmokeTherm) && (<div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px", height: "32px" }}>
          <span style={{ display: "flex", alignItems: "center", fontSize: "16px" }}>Sensitivity:</span>
          <div style={{ display: "flex", alignItems: "center", width: "120px" }}>
            <Dropdown
              styles={{
                root: { marginBottom: "0px", padding: "0px", width: "100%" },
                title: { height: "32px", lineHeight: "32px", textAlign: "center" },
                dropdown: { width: "120px" },
              }}
              options={[
                { key: 0, text: "Low" },
                { key: 1, text: "Medium Low" },
                { key: 2, text: "Medium High" },
                { key: 3, text: "High" },
              ]}
              selectedKey={tempDetectorDaySensitivity} // ✅ Shows the default value
              onChange={(event, option) => setTempDetectorDaySensitivity(option.key)}
            />
          </div>
        </div>)}
        {isSmokeTherm && (<div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px", height: "32px" }}>
          <span style={{ display: "flex", alignItems: "center", fontSize: "16px" }}>Sensor Disablement:</span>
          <div style={{ display: "flex", alignItems: "center", width: "120px" }}>
            <Dropdown
              styles={{
                root: { marginBottom: "0px", padding: "0px", width: "100%" },
                title: { height: "32px", lineHeight: "32px", textAlign: "center" },
                dropdown: { width: "120px" },
              }}
              options={[
                { key: 0, text: "None" },
                { key: 1, text: "Thermal" },
                { key: 2, text: "Smoke" },
              ]}
              selectedKey={tempIntendedDisChannel} // ✅ Shows the default value
              onChange={(event, option) => setTempIntendedDisChannel(option.key)}
            />
          </div>
        </div>)}
        {(isSmoke || isSmokeTherm) && (<div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px" }}>
          <span style={{ fontSize: "16px" }}>Weekly Trend:</span>
          <DefaultButton text={tempDetectorSensitivityWeekCalendar} onClick={() => setIsWeeklyTrendDialogOpen(true)} />
        </div>)}
        <Dialog
          hidden={!isWeeklyTrendDialogOpen}
          onDismiss={() => setIsWeeklyTrendDialogOpen(false)}
          minWidth={"1000px"}
          dialogContentProps={{
            type: DialogType.normal,
            title: "Weekly Trend",
          }}
        >
          <div className="weeklyTrend-buttons-container">
            <div className="weeklyTrend-buttons-frame">
              {Array.from({ length: project.panel.VT5000_CONFIG.WeeklyTrends.length }, (_, i) => {
                const isProgrammed = project.panel.VT5000_CONFIG.WeeklyTrends[i]?.programmed === 1;
                return (
                  <button
                    key={i}
                    className={`weeklyTrend-button ${isProgrammed ? "programmed" : "not-programmed"} ${selectWeeklyTrendBlock === i ? "selected" : ""
                      }`}
                    onClick={() => handleWeeklyTrendBlockClick(i)}
                    disabled={!isProgrammed}
                  >
                    <span>{i + 1}</span>
                  </button>
                );
              })}
            </div>
          </div>
        </Dialog>
        {isSmokeTherm && (<h5 style={{ marginTop: "10px" }}>
          Deactivate Part
        </h5>)}
        {isSmokeTherm && (<div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px", height: "32px" }}>
          <span style={{ display: "flex", alignItems: "center", fontSize: "16px" }}>Day:</span>
          <div style={{ display: "flex", alignItems: "center", width: "120px" }}>
            <Dropdown
              styles={{
                root: { marginBottom: "0px", padding: "0px", width: "100%" },
                title: { height: "32px", lineHeight: "32px", textAlign: "center" },
                dropdown: { width: "120px" },
              }}
              options={[
                { key: 0, text: "None" },
                { key: 1, text: "Thermal" },
                { key: 2, text: "Smoke" },
              ]}
              selectedKey={tempSensSecDisDay} // ✅ Shows the default value
              onChange={(event, option) => setTempSensSecDisDay(option.key)}
            />
          </div>
        </div>)}
        {isSmokeTherm && (<div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px", height: "32px" }}>
          <span style={{ display: "flex", alignItems: "center", fontSize: "16px" }}>Night:</span>
          <div style={{ display: "flex", alignItems: "center", width: "120px" }}>
            <Dropdown
              styles={{
                root: { marginBottom: "0px", padding: "0px", width: "100%" },
                title: { height: "32px", lineHeight: "32px", textAlign: "center" },
                dropdown: { width: "120px" },
              }}
              options={[
                { key: 0, text: "None" },
                { key: 1, text: "Thermal" },
                { key: 2, text: "Smoke" },
              ]}
              selectedKey={tempSensSecDisNight} // ✅ Shows the default value
              onChange={(event, option) => setTempSensSecDisNight(option.key)}
            />
          </div>
        </div>)}
        {isSmokeTherm && (<div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "10px" }}>
          <span style={{ fontSize: "16px" }}>Weekly Trend:</span>
          <DefaultButton text={tempDetectorMultiSenseWeekCalendar} onClick={() => setIsDeactivateWeeklyTrendDialogOpen(true)} />
        </div>)}
        <Dialog
          hidden={!isDeactivateWeeklyTrendDialogOpen}
          onDismiss={() => setIsDeactivateWeeklyTrendDialogOpen(false)}
          minWidth={"1000px"}
          dialogContentProps={{
            type: DialogType.normal,
            title: "Weekly Trend",
          }}
        >
          <div className="weeklyTrend-buttons-container">
            <div className="weeklyTrend-buttons-frame">
              {Array.from({ length: project.panel.VT5000_CONFIG.WeeklyTrends.length }, (_, i) => {
                const isProgrammed = project.panel.VT5000_CONFIG.WeeklyTrends[i]?.programmed === 1;
                return (
                  <button
                    key={i}
                    className={`weeklyTrend-button ${isProgrammed ? "programmed" : "not-programmed"} ${selectDeactivateWeeklyTrendBlock === i ? "selected" : ""
                      }`}
                    onClick={() => handleDeactivateWeeklyTrendBlockClick(i)}
                    disabled={!isProgrammed}
                  >
                    <span>{i + 1}</span>
                  </button>
                );
              })}
            </div>
          </div>
        </Dialog>
      </div>
    );
  };

  const onSave = () => {
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].name = tempName;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].isRadio = tempIsRadio ? 1 : 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].evacuationEnabled = tempEvacuationEnabled ? 1 : 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].volume = tempVolume;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].tone = tempTone;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].alarmVerification = tempAlarmVerification ? 1 : 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].alarmVerificationDelay = tempAlarmVerificationDelay;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].technical = tempTechnical ? 1 : 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].prealarm = tempPrealarm ? 1 : 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].preAllTemp = tempPreAllTemp;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].sounderBase = tempSounderBase ? 1 : 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].dayNight = tempDayNight;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].detectorDaySensitivity = tempDetectorDaySensitivity;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].intendedDisChannel = tempIntendedDisChannel;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].detectorSensitivityWeekCalendar = tempDetectorSensitivityWeekCalendar;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].programmed = 1;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].technicalFault = tempTechnicalFault ? 1 : 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].technicalRestore = tempTechnicalRestore ? 1 : 0;
    if (tempSensSecDisNight === 1) {
      if (tempSensSecDisDay === 0) {
        project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].sensSecDis = 5;
        project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].secDisEn = 1;
      } else if (tempSensSecDisDay === 1) {
        project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].sensSecDis = 7;
        project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].secDisEn = 1;
      } else {
        project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].sensSecDis = 6;
        project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].secDisEn = 1;
      }
    } else if (tempSensSecDisNight === 2) {
      if (tempSensSecDisDay === 0) {
        project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].sensSecDis = 2;
        project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].secDisEn = 1;
      } else if (tempSensSecDisDay === 1) {
        project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].sensSecDis = 4;
        project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].secDisEn = 1;
      } else {
        project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].sensSecDis = 3;
        project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].secDisEn = 1;
      }
    } else {
      if (tempSensSecDisDay === 0) {
        project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].sensSecDis = 0;
        project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].secDisEn = 0;
      } else if (tempSensSecDisDay === 1) {
        project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].sensSecDis = 1;
        project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].secDisEn = 1;
      } else {
        project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].sensSecDis = 0;
        project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].secDisEn = 1;
      }
    }
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].detectorMultiSenseWeekCalendar = tempDetectorMultiSenseWeekCalendar;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].lastTipo = 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].isMultiSensor = 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].deviceType = 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].isCallPoint = 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].isGas = 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].isFlasher = 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].isSounder = 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].isRepeater = 0;
    if (selectedDeviceType === "Thermal") {
      project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].lastTipo = 1;
    } else if (selectedDeviceType === "Smoke Therm.") {
      project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].isMultiSensor = 1;
    } else if (selectedDeviceType === "Input") {
      project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].deviceType = 1;
      project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].lastTipo = 3;
    } else if (selectedDeviceType === "Call point") {
      project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].deviceType = 1;
      project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].isCallPoint = 1;
      project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].lastTipo = 3;
    } else if (selectedDeviceType === "Gas") {
      project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].deviceType = 1;
      project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].isGas = 1;
      project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].lastTipo = 3;
    } else if (selectedDeviceType === "Output") {
      project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].deviceType = 1;
      project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].lastTipo = 4;
    } else if (selectedDeviceType === "Flasher") {
      project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].deviceType = 1;
      project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].lastTipo = 4;
      project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].isFlasher = 1;
    } else if (selectedDeviceType === "Siren") {
      project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].deviceType = 1;
      project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].lastTipo = 4;
      project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].isSounder = 1;
    } else if (selectedDeviceType === "Rep.Led") {
      project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].deviceType = 1;
      project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].lastTipo = 4;
      project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].isRepeater = 1;
    } else if (selectedDeviceType === "XPander") {
      project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].deviceType = 1;
      project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].lastTipo = 5;
    }

    const userEmail = localStorage.getItem('userEmail');
    Axios.post(`${process.env.REACT_APP_BACKEND_URL}/update_panel_devices`, {
      projectId: project.project_id,
      argusTablePr: project.panel.VT5000_CONFIG.ArgusTablePr
    })
      .then((response) => {
        if (response.data.success) {
          console.log("Devices settings updated successfully");
        } else {
          console.error("Failed to update devices settings");
          resetPanel();
        }
      })
      .catch((error) => {
        console.error("Error updating devices settings:", error);
        resetPanel();
      });
    dismissPanel();
    setSelectedDeviceType(null);
    setSelectedDevice(null);
  };

  const onRemove = () => {
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].name = "";
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].isRadio = 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].evacuationEnabled = 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].volume = 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].tone = 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].alarmVerification = 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].alarmVerificationDelay = 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].technical = 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].prealarm = 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].preAllTemp = 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].sounderBase = 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].dayNight = 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].detectorDaySensitivity = 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].intendedDisChannel = 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].detectorSensitivityWeekCalendar = 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].programmed = 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].technicalFault = 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].technicalRestore = 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].sensSecDis = 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].secDisEn = 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].detectorMultiSenseWeekCalendar = 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].lastTipo = 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].isMultiSensor = 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].deviceType = 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].isCallPoint = 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].isGas = 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].isFlasher = 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].isSounder = 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].isRepeater = 0;
    

    const userEmail = localStorage.getItem('userEmail');
    Axios.post(`${process.env.REACT_APP_BACKEND_URL}/update_panel_devices`, {
      projectId: project.project_id,
      argusTablePr: project.panel.VT5000_CONFIG.ArgusTablePr
    })
      .then((response) => {
        if (response.data.success) {
          console.log("Device delete successfully");
        } else {
          console.error("Failed to delete device");
          resetPanel();
        }
      })
      .catch((error) => {
        console.error("Error deleting device:", error);
        resetPanel();
      });
    dismissPanel();
    setSelectedDeviceType(null);
    setSelectedDevice(null);
  }

  const onCancel = () => {
    setTempName(name);
    setTempIsRadio(isRadio);
    setTempEvacuationEnabled(evacuationEnabled);
    setTempVolume(volume);
    setTempTone(tone);
    setTempAlarmVerification(alarmVerification);
    setTempAlarmVerificationDelay(alarmVerificationDelay);
    setTempTechnical(technical);
    setTempPrealarm(prealarm);
    setTempPreAllTemp(preAllTemp);
    setTempSounderBase(sounderBase);
    setTempDayNight(dayNight);
    setTempDetectorDaySensitivity(detectorDaySensitivity);
    setTempIntendedDisChannel(intendedDisChannel);
    setTempDetectorSensitivityWeekCalendar(detectorSensitivityWeekCalendar);
    setTempTechnicalFault(technicalFault);
    setTempTechnicalRestore(technicalRestore);
    switch (sensSecDis) {
      case 7:
        setTempSensSecDisDay(1);
        setTempSensSecDisNight(1);
        setTempSecDisEn(1);
        break;
      case 6:
        setTempSensSecDisDay(2);
        setTempSensSecDisNight(1);
        setTempSecDisEn(1);
        break;
      case 5:
        setTempSensSecDisDay(0);
        setTempSensSecDisNight(1);
        setTempSecDisEn(1);
        break;
      case 4:
        setTempSensSecDisDay(1);
        setTempSensSecDisNight(2);
        setTempSecDisEn(1);
        break;
      case 3:
        setTempSensSecDisDay(2);
        setTempSensSecDisNight(2);
        setTempSecDisEn(1);
        break;
      case 2:
        setTempSensSecDisDay(0);
        setTempSensSecDisNight(2);
        setTempSecDisEn(1);
        break;
      case 1:
        setTempSensSecDisDay(1);
        setTempSensSecDisNight(0);
        setTempSecDisEn(1);
        break;
      default:
        if (secDisEn === 0) {
          setTempSensSecDisDay(0);
          setTempSensSecDisNight(0);
          setTempSecDisEn(0);
        }
        else {
          setTempSensSecDisDay(2);
          setTempSensSecDisNight(0);
          setTempSecDisEn(1);
        }
    }
    setTempDetectorMultiSenseWeekCalendar(detectorMultiSenseWeekCalendar);
    dismissPanel();
    setSelectedDeviceType(null);
    setSelectedDevice(null);
  };

  const resetPanel = () => {
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].name = name;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].isRadio = tempIsRadio ? 1 : 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].evacuationEnabled = evacuationEnabled ? 1 : 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].volume = volume;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].tone = tone;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].alarmVerification = alarmVerification ? 1 : 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].alarmVerificationDelay = alarmVerificationDelay;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].technical = technical ? 1 : 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].prealarm = prealarm ? 1 : 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].preAllTemp = preAllTemp;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].sounderBase = sounderBase ? 1 : 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].dayNight = dayNight;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].detectorDaySensitivity = detectorDaySensitivity;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].intendedDisChannel = intendedDisChannel;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].detectorSensitivityWeekCalendar = detectorSensitivityWeekCalendar;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].sensSecDis = sensSecDis;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].detectorMultiSenseWeekCalendar = detectorMultiSenseWeekCalendar;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].technicalFault = technicalFault ? 1 : 0;
    project.panel.VT5000_CONFIG.ArgusTablePr[selectedLoop][selectedDevice].technicalRestore = technicalRestore ? 1 : 0;
  }

  const onRenderFooterContent = () => (
    <div>
      <PrimaryButton onClick={onSave} styles={{ root: { marginRight: 8 } }}>
        Save
      </PrimaryButton>
      <DefaultButton onClick={onRemove} styles={{ root: { marginRight: 8 } }}>Remove</DefaultButton>
      <DefaultButton onClick={onCancel}>Cancel</DefaultButton>
    </div>
  );

  return (
    <div className="devices-content">
      {/* Loop Buttons */}
      <div className="loop-buttons">
        <span>Loop:</span>
        {Array.from({ length: loopButtonsCount }, (_, index) => (
          <button
            key={index}
            className={`loop-button ${selectedLoop === index ? "selected-loop" : ""}`}
            onClick={() => handleLoopButtonClick(index)}
          >
            {index + 1}
          </button>
        ))}
      </div>

      {/* Device Buttons */}
      <div className="device-buttons-container">
        <div className="device-buttons-frame">
          {Array.from({ length: project.panel.VT5000_CONFIG.ArgusTablePr[0].length }, (_, index) => {
            const i = selectedLoop; // Loop index
            const j = index; // Device index
            const device = project.panel.VT5000_CONFIG.ArgusTablePr?.[i]?.[j];
            const isProgrammed = device?.programmed === 1;
            const isModule = isProgrammed && (device.deviceType === 1);
            const isDevice = isProgrammed && (device.deviceType === 0);
            const isSmoke = isDevice && (device.lastTipo === 0) && (device.isMultiSensor === 0);
            const isThermal = isDevice && (device.lastTipo === 1);
            const isSmokeTherm = isDevice && (device.lastTipo === 0) && (device.isMultiSensor === 1);
            const isCallPoint = isModule && (device.lastTipo === 3) && (device.isCallPoint === 1);
            const isGas = isModule && (device.lastTipo === 3) && (device.isGas === 1);
            const isInput = isModule && (!isCallPoint) && (!isGas);
            const isFlasher = isModule && (device.lastTipo === 4) && (device.isFlasher === 1);
            const isSiren = isModule && (device.lastTipo === 4) && (device.isSounder === 1);
            const isRepeater = isModule && (device.lastTipo === 4) && (device.isRepeater === 1);
            const isOutput = isModule && (!isFlasher) && (!isSiren) && (!isRepeater);
            const isExpander = isModule && (device.lastTipo === 5);

            let buttonClass = "not-programmed"; // Default class
            // if (isProgrammed) {
            //   buttonClass = device?.deviceType === 0 ? "sensor" : "input";
            // }
            if (isModule) {
              buttonClass = "module";
            }
            else if (isSmoke) {
              buttonClass = "smoke";
            }
            else if (isThermal) {
              buttonClass = "heat";
            }
            else if (isSmokeTherm) {
              buttonClass = "smokeTherm";
            }

            return (
              <button
                key={index}
                className={`device-button ${buttonClass}`}
                onClick={() => handleDeviceButtonClick(index)}
              >
                <span>{index + 1}</span>
              </button>
            );
          })}
        </div>
      </div>

      {/* Fluent UI Panel */}
      <Panel
        isOpen={isPanelOpen}
        onDismiss={dismissPanel}
        headerText={`Device ${selectedDevice !== null ? selectedDevice + 1 : ""}`}
        type={PanelType.custom}
        customWidth="400px"
        closeButtonAriaLabel="Close"
        onRenderFooterContent={onRenderFooterContent}
        isFooterAtBottom={true}
      >
        {renderPanelContent()}
      </Panel>
    </div>
  );
};

export default DevicesContent;
